/**
 * Helpers partagés des blocs CMS publics (interpolation, variables, film photo).
 */
import React from "react";
import {
  Castle, BedDouble, Trees, Heart, Wine, Music, Handshake, Car, Users, Sparkles,
  Sun, MapPin, Camera, Utensils, Flame, Baby, Tent, CalendarHeart, Star, Gift,
  PartyPopper, Briefcase, Brain, Mic, Package, Rocket, GraduationCap, Puzzle,
  Monitor, Coffee, Wifi, Presentation, Trophy,
} from "lucide-react";
import { track } from "../../lib/events";

/** Icônes disponibles pour le bloc feature_grid (champ `icon`). */
export const FEATURE_ICONS = {
  castle: Castle, bed: BedDouble, trees: Trees, heart: Heart, wine: Wine,
  music: Music, handshake: Handshake, car: Car, users: Users, sparkles: Sparkles,
  sun: Sun, map: MapPin, camera: Camera, utensils: Utensils, flame: Flame,
  baby: Baby, tent: Tent, calendar: CalendarHeart, star: Star, gift: Gift, party: PartyPopper,
  briefcase: Briefcase, brain: Brain, mic: Mic, package: Package, rocket: Rocket,
  graduation: GraduationCap, puzzle: Puzzle, monitor: Monitor, coffee: Coffee,
  wifi: Wifi, presentation: Presentation, trophy: Trophy,
};

// Étiquettes affichées pour le champ "certitude" (fiabilité historique)
export const CERTITUDE_LABEL = {
  documented: "Documenté",
  probable: "Probable",
  testimony: "Témoignage",
  to_confirm: "À confirmer",
  context: "Contexte historique",
};

/** Filtre CSS assombrissant pour les photos simples (film_enabled / film_opacity, défaut désactivé). */
export function filmStyle(d) {
  if (!d?.film_enabled) return undefined;
  const o = Math.min(Math.max((d.film_opacity ?? 30) / 100, 0), 0.85);
  return { filter: `brightness(${(1 - o).toFixed(2)})` };
}

export const absUrl = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : null);

export const WEDDING_PILLAR = "/mariages/le-domaine-pour-votre-mariage";

/** GA4 + analytics interne : événements de la page pilier mariage. */
export function trackMariage(name, props = {}) {
  track(name, props);
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, { page_path: WEDDING_PILLAR, ...props });
  } catch { /* GA absent */ }
}

const VARS_CACHE_KEY = "briouse:cms:variables:v1";
export function useVariables() {
  const [vars, setVars] = React.useState(() => {
    try {
      const cached = sessionStorage.getItem(VARS_CACHE_KEY);
      return cached ? JSON.parse(cached) : {};
    } catch { return {}; }
  });
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/cms/variables`)
      .then(r => r.json())
      .then((v) => {
        setVars(v || {});
        try { sessionStorage.setItem(VARS_CACHE_KEY, JSON.stringify(v || {})); } catch { /* ignore */ }
      })
      .catch(() => {});
  }, []);
  return vars;
}

export function interpolate(str, vars, unit) {
  if (!str) return str;
  return str.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (m, key) => {
    // Variables d'hébergement : {{unit.capacity}} {{unit.bedrooms}} etc.
    if (key.startsWith("unit.") && unit) {
      const field = key.slice(5);
      const val = unit[field];
      if (val === null || val === undefined || val === "") return m;
      if (typeof val === "boolean") return val ? "oui" : "non";
      return String(val);
    }
    const v = vars[key];
    if (!v) return m;
    if (v.type === "money" && v.value_cents != null) return `${(v.value_cents / 100).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} €`;
    if (v.type === "number" && v.value_number != null) return String(v.value_number);
    return v.value_text || "";
  });
}
